import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'

const columns = [
  { title: 'Product', prop: 'product_id', references: 'admin/products', referenceProp: 'name' },
  { title: 'Category', prop: 'category_id', references: 'admin/categories', referenceProp: 'name' },
  { title: 'Created', prop: 'created_at', format: 'fromNow' },
  { title: 'Updated', prop: 'updated_at', format: 'fromNow' }
]

const filters = [
  { name: 'Filter by category', prop: 'filters.category_id', type: 'autocomplete', references: 'admin/categories', referenceProp: 'name', enabled: true, customFilters: { type: 'product' } },
  { name: 'Filter by product', prop: 'filters.product_id', type: 'autocomplete', references: 'admin/products', referenceProp: 'name', enabled: true }
]

const defaults = {
  order: [{ column: 'created_at', direction: 'desc' }]
}

const ProductCategories = (props) => (
  <List
    title='Product Categories'
    apiPath='admin/product_categories'
    columns={columns}
    filters={filters}
    defaults={defaults}
    buildMenuItems={menuItems}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
    withExport
  />
)

export default ProductCategories
